module.exports = __webpack_public_path__ + "assets/032fb785c91b2eb138231da2991e35ea.png";